import axios from "axios";

export const getTitleAndEscrowFromApi = (listingId) => axios.get(`/listings/${listingId}/blueprint_title`);

export const dismissCardFromApi = () => axios.get(`/users/dismiss_blueprint_info_card`);

export const sendBlueprintRequestFromApi = (listingId) =>
  axios.get(`/listings/${listingId}/blueprint_title/inform`);

export const submitBlueprintToApi = (listingId, payload) =>
  axios.post(`/listings/${listingId}/blueprint_title`, {
    blueprint_title: { ...payload },
    authenticity_token: window.ReactOnRails.authenticityToken(),
  });
